class Sorting {
  /** Sorting orders */
  get ORDER () {
    return {
      DEFAULT: 0,
      ASC: 1,
      DESC: -1
    }
  }

  constructor (key = '') {
    this.key = key
    this.order = this.ORDER.DESC
  }

  /**
   * @param {string} key The key to sort by.
   */
  sortBy (key) {
    /** Changing orders: DESC > ASC > DEFAULT */
    if (this.key === key) {
      if (this.order === this.ORDER.ASC) {
        this.key = ''
        this.order = this.ORDER.DEFAULT
      } else {
        this.order =
          this.order === this.ORDER.DESC
            ? this.ORDER.ASC
            : this.ORDER.DESC
      }
    } else {
      this.key = key
      this.order = this.ORDER.DESC
    }
  }

  /**
   * @param {!Array<string>} data The data set to sort.
   * @param {string=} locale The locale for sorting options.
   */
  sort (data, locale = '') {
    let _data = [...data]
    const key = this.key
    if (key) {
      _data = _data.sort((a, b) => {
        const ref = this.order === this.ORDER.ASC ? a : b
        const compare = this.order === this.ORDER.ASC ? b : a
        const options = {}
        if (!isNaN(ref[key]) && !isNaN(compare[key])) {
          options.numeric = true
        }

        return String(ref[key]).localeCompare(String(compare[key]), locale, options)
      })
    }
    return _data
  }
}

export default Sorting
